import { useParams } from "react-router-dom";

import UserDetails from "./user/UserDetails";
import EnvironmentDetails from "./environment/EnvironmentDetails";
import SyncLogsDetails from "./syncLogs/SyncLogsDetails";
import DomainLogsDetails from "./log/DomainLogsDetails";
import DeploymentDetails from "./deployment/DeploymentDetails";
import { useMemo } from "react";
import RootDomainDetails from "./domain/RootDomainDetails";
import AuditTrailView from "./auditTrail/AuditTrailView";
import ProductVersionDetails from "./productVersion/ProductVersionDetails";
import EnvironmentTemplateDetails from "./environmentTemplate/EnvironmentTemplateDetails";

const DetailsContainer = () => {
    const { objectType, id, objectSubType } = useParams();

    const render = useMemo(() => {
        switch (objectType) {
            case "user":
                return <UserDetails />
            case "domain-logs":
                return <DomainLogsDetails />
            case "domain":
                return <RootDomainDetails id={id} />
            case "environment":
                if (objectSubType === "deployment") {
                    return <DeploymentDetails />
                }
                return <EnvironmentDetails />
            case "audit-trail": {
                return <AuditTrailView />
            }
            case "products": {
                return <ProductVersionDetails />
            }
            case "support-logs": {
                return <SyncLogsDetails />
            }
            case "environment-templates":
                return <EnvironmentTemplateDetails />
            default: {
                return <></>
            }
        }
    }, [objectType, objectSubType, id]);

    return <div className="mt-n3 d-flex flex-column overflow-auto">{render}</div>;
};

export default DetailsContainer;
